<script>
    import { Basket } from "../../stores/basket";

    import { Modal } from "../../stores/modal";
    import moment from "moment";
    import Datepicker from 'svelte-calendar';
    import Products from '../../../models/Products';

	var isMobile = navigator.userAgent.match(/(iPad)|(iPhone)|(iPod)|(android)|(webOS)/i);
    let date = $Basket.deleveryDate;
    if(!isMobile){
        date = $Basket.deleveryDate ? moment($Basket.deleveryDate).toDate() == 'Invalid Date' ? new Date() : moment($Basket.deleveryDate).toDate() : new Date();
    }
    let product;
    let update = false;
    if($Basket.items.find(item => item.item_num == $Modal.data.product.item_num)){
        product = $Basket.items.find(item => item.item_num == $Modal.data.product.item_num);
        product.pricelist_by_avl_sizes.forEach(priceItem => {
            if(!priceItem.messages)
            priceItem.messages = [];
            if(priceItem.messages.length < priceItem.quantity)
            priceItem.messages = [...priceItem.messages, ...(new Array(priceItem.quantity - priceItem.messages.length))]
            else if(priceItem.messages.length > priceItem.quantity)
            priceItem.messages = [...priceItem.messages.slice(0, priceItem.quantity - priceItem.messages.length)]
        })
        update = true;
    }else{
        product = $Modal.data.product;
    }
    $: date, (()=>{
        let updateDate = isMobile ? date : moment(date).format("YYYY-MM-DD")
        Basket.setDate(updateDate);
    })()

    //$: allowChange = $Basket.deleveryDate && product.pricelist_by_avl_sizes.reduce((t,c) => t+(c.quantity ? parseInt(c.quantity) : 0), 0);
    $: allowChange = product.pricelist_by_avl_sizes.reduce((t,c) => t+(c.quantity ? parseInt(c.quantity) : 0), 0);
</script>
<img src={product.item_img} class="img-responsive product-modal-img">
<div class="row">
    <div class="col">
        <p>
            {product.description}
        </p>
    </div>
</div>
<!-- <div class="row no-gutters mt-20">
    <div class="form-group w-100">
        <label class="lbl-txt">Date:</label>
        {#if isMobile}
            <input class="form-control form-control-sm" type="date" placeholder="date" bind:value={date} min={moment().format("YYYY-MM-DD")}>
        {:else}
            <div class="row no-gutters">
                <span class="form-control form-control-sm col-8 text-center">{moment($Basket.deleveryDate).format('Do MMMM YYYY')}</span>
                <div class="col-4">
                    <Datepicker class="col-4" start={new Date()} bind:selected={date} format={''}/>
                </div>
            </div>
        {/if}
    </div>
</div> -->
{#each product.pricelist_by_avl_sizes as priceItem}
    <div class="row sizes">
        <div class="col item-quantity"><button class="btn btn-default">{priceItem.size}</button></div>
        <div class="col">
            {#if priceItem.select_max > 0}
                <select class="form-control quantity-box"
                placeholder="Quantity"
                bind:value={priceItem.quantity}
                on:change={e => {
                    if(!priceItem.messages)
                    priceItem.messages = [];
                    if(priceItem.messages.length < priceItem.quantity)
                    priceItem.messages = [...priceItem.messages, ...(new Array(priceItem.quantity - priceItem.messages.length))]
                    else if(priceItem.messages.length > priceItem.quantity)
                    priceItem.messages = [...priceItem.messages.slice(0, priceItem.quantity - priceItem.messages.length)]
                }}
                >
                    <option value="0">Quantity</option>
                    <option value="0">0</option>
                    {#each [...Array(parseInt(priceItem.select_max)).keys()] as i}
                        <option value={i+1}>{i+1}</option>
                    {/each}
                </select>
            {:else}
                <p class="alert alert-danger">Out of stock</p>
            {/if}
        </div>
        <div class="col">
            <p class="item-cost">
                &#8377; {priceItem.cost}
            </p>
        </div>
    </div>
    {#if priceItem.quantity > 0}
        <div class="form-group w-100">
            <label class="lbl-txt">Message:</label>
            {#if priceItem.messages}
                {#each priceItem.messages as message,i}
                    <input class="form-control mb-2" bind:value={message} maxlength="40" placeholder="Message on cake {i+1}" />
                {/each}
            {/if}
        </div>
    {/if}
{/each}

<div class="modal-footer">
    <button type="button" class="btn btn-primary" disabled={!allowChange} on:click|preventDefault={e => {
        product.pricelist_by_avl_sizes.forEach((size,i) => {
            if(size.quantity && size.quantity > 0){
                (new Array(parseInt(size.quantity))).forEach((j,k) => {
                    if(!size.messages[k])
                    product.pricelist_by_avl_sizes[i].messages[k] = "";
                })
            }else{
                product.pricelist_by_avl_sizes[i].quantity = 0;
                product.pricelist_by_avl_sizes[i].messages = [];
            }
        })
        if(update){
            Basket.updateItem(product)
        }else{
            Basket.add(product);
        }
        Modal.close();
    }}>{update ? "Update" : "Add to basket"}</button>
</div>
<style lang="scss">
    

    .sizes {
        padding: 10px 0;

        .btn {
            color: var(--primary);
            border: 2px solid var(--primary);
            width: 100%;
            border-radius: 8px;
            padding: 5px 10px;

            &.selected {
                background-color: var(--primary);
                color: #fff;
            }
        }
    }

    .product-modal-img {
        max-height: 200px;
        margin-bottom: 20px;
    }

    .lbl-txt {
        font-size: 14px;
        font-weight: 600;
    }

    .item-quantity {
        min-width: 130px;
        margin-bottom: 15px;
        max-width: 150px;
    }

    .pl-0 {
        padding-left: 0;
    }

    .item-cost {
        margin: 13px 0 0 0;
    }

    .quantity-box {
        max-width: 120px;
    }
</style>